import { PlaybackError } from "@/lib/errors";
import styles from "@/styles/Video.module.scss";
import config from "@/lib/config";
import { Button } from "@/components/Buttons";
import { chatEnableErrorCodes } from "@/lib/constants";

export default function OverlayError({
  error,
  poster,
  isChatAvailableMeta,
  setChatDisplay,
}) {
  const isPlaybackLocationError =
    error instanceof PlaybackError &&
    (error?.code === "P-2054" || error?.code === "P-2055");
  const errorCode = error?.code || "E-500";
  const message =
    error.message ?? "エラーが発生しました。しばらく経ってからお試しください。";
  const isChatEnableError =
    isChatAvailableMeta && chatEnableErrorCodes.includes(errorCode);

  if (poster) {
    return (
      <div className={styles.withPoster}>
        <div
          className={styles.poster}
          style={{ backgroundImage: `url(${poster})` }}
        />
        <div className={styles.message}>
          <div>
            <h3 className={styles.overlayError}>{message}</h3>
            <div className={styles.overlayErrorCode}>code: {errorCode}</div>
            {isChatEnableError && (
              <Button fillColor medium onClick={() => setChatDisplay(true)}>
                チャットのみ利用する
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <h3 className={styles.overlayError}>{message}</h3>
        <div className={styles.overlayErrorCode}>code: {errorCode}</div>
        {isPlaybackLocationError && (
          <div className={styles.overlayLocationError}>
            <br />
            <p>
              地域判定エラーについてのヘルプはこちら
              <br />
              <a
                href={config.staticLinks.geoRestriction}
                className={styles.linkText}
              >
                {config.staticLinks.geoRestriction}
              </a>
            </p>
          </div>
        )}
        {isChatEnableError && (
          <Button fillColor medium onClick={() => setChatDisplay(true)}>
            チャットのみ利用する
          </Button>
        )}
      </div>
    );
  }
}
